import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import ChevronDown from '../../common/Icons/ChevronDown';
import Tooltip from '../../common/Tooltip/Tooltip';
import AvatarRenderer from '../../common/AvatarRenderer/AvatarRenderer';
import {
  SectionHeaderStyled,
  SectionItemsContainer,
  StudentListSectionStyled,
} from './StudentListSection.styled';

const SectionHeader = ({
  toggleSection,
  isOpen,
  groupControlItems,
  name,
  count,
  hasItems,
}) => {
  const { t } = useTranslation();

  return (
    <SectionHeaderStyled
      data-testid="submission-section-header"
      isOpen={isOpen}
      onClick={toggleSection}
      clickable={hasItems}
    >
      <div className="student-info" data-dd-privacy="mask">
        <span>{t(name)}</span>
        <span className="students-count">({count})</span>
        {hasItems ? (
          <span className="toggle-icon">
            <ChevronDown color={'#4a4a4a'} size={16} />
          </span>
        ) : null}
      </div>
      {groupControlItems && (
        <div className="group-control-items">{groupControlItems}</div>
      )}
    </SectionHeaderStyled>
  );
};

SectionHeader.defaultProps = {
  groupControlItems: null,
};

SectionHeader.propTypes = {
  toggleSection: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  groupControlItems: PropTypes.element,
  name: PropTypes.string.isRequired,
  hasItems: PropTypes.bool.isRequired,
  count: PropTypes.string.isRequired,
};

export const StudentInfo = ({ avatar, studentName, studentUsername }) => (
  <div className="student-info usprivacy" data-recording-sensitive>
    <span data-testid={`avatar-${studentUsername}`} className="student-avatar">
      <AvatarRenderer src={avatar} size={20} />
    </span>
    <span
      className="student-name usprivacy"
      data-html={true}
      data-tip={
        studentUsername
          ? `<div class="usprivacy" data-recording-sensitive>${studentName} - ${studentUsername}</div>`
          : ''
      }
      data-testid="student-name"
    >
      {studentName}
    </span>
  </div>
);

StudentInfo.defaultProps = {
  avatar: '',
};

StudentInfo.propTypes = {
  avatar: PropTypes.string,
  studentName: PropTypes.string.isRequired,
  studentUsername: PropTypes.string.isRequired,
};

export const StudentListSection = ({
  customCount,
  groupControlItems,
  sectionItems,
  sectionName,
  submissions,
  ...rest
}) => {
  const [isOpen, setisOpen] = React.useState(true);

  useEffect(
    () => {
      ReactTooltip.rebuild();
    },
    [submissions],
  );

  const count = (submissions && submissions.length) || 0;

  // if submissions !== null then render
  return (
    submissions && (
      <StudentListSectionStyled data-testid={rest['data-testid']}>
        <SectionHeader
          hasItems={count}
          count={count}
          name={sectionName}
          isOpen={isOpen}
          toggleSection={() => setisOpen(prev => !prev)}
          groupControlItems={groupControlItems}
        />
        {isOpen && (
          <SectionItemsContainer isOpen={isOpen}>
            {sectionItems}
          </SectionItemsContainer>
        )}
        {isOpen && <Tooltip />}
      </StudentListSectionStyled>
    )
  );
};

StudentListSection.defaultProps = {
  submissions: null,
  groupControlItems: null,
  customCount: 0,
  sectionItems: null,
};

StudentListSection.propTypes = {
  groupControlItems: PropTypes.element,
  sectionName: PropTypes.string.isRequired,
  customCount: PropTypes.string,
  sectionItems: PropTypes.elementType,
  submissions: PropTypes.arrayOf(PropTypes.any),
};
